import { fontSizes, fontWeights, lineHeight } from '@ohgoodlord/design-system'
import styled from 'styled-components'
import { colors } from '../../../common/colors'

export const Card = styled.div`
  background: ${colors.white};
  border: 1px solid ${colors.greyscale6};
  border-radius: 10px;
  padding: 16px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const SectionHeading = styled.h2`
  margin: 0;
  font-size: ${fontSizes.l};
  font-weight: ${fontWeights.bold};
  line-height: ${lineHeight};
  color: ${colors.greyscale2};
`

export const SectionBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`

export const PrimaryButton = styled.button`
  appearance: none;
  border: none;
  cursor: pointer;
  background: ${colors.primary};
  color: ${colors.greyscale2};
  border-radius: 4px;
  padding: 11px 25px;
  width: 100%;
  font-size: ${fontSizes.m};
  font-weight: ${fontWeights.normal};
  line-height: ${lineHeight};
  text-align: center;

  &:hover {
    opacity: 0.92;
  }

  &:focus-visible {
    outline: 2px solid ${colors.navyBlue};
    outline-offset: 2px;
  }
`

export const SupportingText = styled.p`
  margin: 0;
  font-size: ${fontSizes.s};
  font-weight: ${fontWeights.normal};
  line-height: ${lineHeight};
  color: ${colors.greyscale2};
`

export const BodyText = styled.p`
  margin: 0;
  font-size: ${fontSizes.m};
  font-weight: ${fontWeights.normal};
  line-height: ${lineHeight};
  color: ${colors.greyscale2};
`

export const Subheading = styled.h3`
  margin: 0;
  font-size: ${fontSizes.m};
  font-weight: ${fontWeights.bold};
  line-height: ${lineHeight};
  color: ${colors.greyscale2};
`

export const Subsection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`

export const BulletList = styled.ul`
  margin: 0;
  padding-left: 24px;
  font-size: ${fontSizes.m};
  font-weight: ${fontWeights.normal};
  line-height: ${lineHeight};
  color: ${colors.greyscale2};

  li {
    margin-bottom: 0;
  }
`
